const messaging = `
  messageCode
  name
  messageType
  message`;

export default messaging;
